import { useMemo } from "react";
import {
  type FormulaValidationResult,
  validateFormula,
} from "../formula/validateFormula";

interface UseFormulaValidationResult {
  result: FormulaValidationResult;
}

const useFormulaValidation = (
  expression: string,
  allowedCodes: string[],
  opDataCodes: string[],
): UseFormulaValidationResult =>
  useMemo(
    () => ({
      result: validateFormula(expression, { allowedCodes, opDataCodes }),
    }),
    [expression, allowedCodes, opDataCodes],
  );

export default useFormulaValidation;
